import { ROLES } from "../constants";
import { v4 as uuidv4 } from "uuid";

export const getUserRole = (userRole) => {
  return ROLES.get(userRole) || userRole;
};

export const generateTraceId = () => uuidv4();

const PAYMENT_METHOD_ALIASES = {
  creditcard: "credit_card",
  billet: "boleto",
};

export const normalizeSubscriptionPaymentMethod = (paymentMethod) => {
  if (!paymentMethod) return paymentMethod;
  const normalized = String(paymentMethod).toLowerCase();
  return PAYMENT_METHOD_ALIASES[normalized] ?? normalized;
};